import { useQuery } from '@tanstack/react-query';
import { getMunicipality } from '@/services/generic';

export const useMunicipality = () => {
  const queryKey = ['municipality'];
  return useQuery({
    queryKey,
    queryFn: getMunicipality,
    select: (data) =>
      data.map((item) => ({
        label: `${item.name}, ${item?.department?.name}, ${item?.department?.country?.name}`,
        value: item.id,
      })),
  });
};
